(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const preview = document.body.dataset.preview === 'true';
  const params = new URLSearchParams(location.search);
  const locale = document.documentElement.lang.toLowerCase();
  const language = locale.startsWith('zh') ? 'zh' : locale.startsWith('en') ? 'en' : 'ja';
  const translations = window.LIVEARO_I18N || { strings: {}, sampleNames: {}, formFields: {}, projects: {} };
  const tr = (key, variables = {}) => {
    const entry = translations.strings[key] || {};
    let message = entry[language] || entry.ja || key;
    Object.entries(variables).forEach(([name, value]) => { message = message.replaceAll('{' + name + '}', value); });
    return message;
  };
  const productName = name => translations.sampleNames[name]?.[language] || name;
  const productText = text => text.split('、').map(productName).join(tr('sampleSeparator'));
  const displayCode = color => String(color.displayCode?.[language] || color.code);
  const catalog = window.LIVEARO_CATALOG;
  let requestedColors = [];
  try {
    const raw = JSON.parse(params.get('colors') || '[]');
    if (Array.isArray(raw) && catalog) {
      const seen = new Set();
      requestedColors = raw.slice(0, 300).flatMap(item => {
        if (!item || typeof item !== 'object') return [];
        const product = catalog.products.find(p => p.id === item.productId);
        const color = product?.colors.find(c => c.id === item.colorId);
        const key = product?.id + ':' + color?.id;
        if (!color || seen.has(key)) return [];
        seen.add(key);
        return [(product.title[language] || product.title.ja) + ' / ' + displayCode(color)];
      });
    }
  } catch (_) { /* Ignore malformed enquiry parameters. */ }
  const specialtyProduct = window.LIVEARO_SPECIALTY?.products?.find(product => product.id === params.get('specialty'));
  const requestedSpecialty = specialtyProduct ? [
    specialtyProduct.title?.[language] || specialtyProduct.title?.ja,
    specialtyProduct.color?.[language] || specialtyProduct.color?.ja
  ].filter(Boolean).join(' / ') : '';
  let toastTimer;
  const showToast = message => {
    const toast = $('.toast');
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.hidden = false;
    toastTimer = setTimeout(() => { toast.hidden = true; }, 3200);
  };
  function bindUI(root = document) {
    $$('[data-menu-toggle]', root).forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      const close = () => {
        menu.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', tr('menuOpen'));
      };
      button.addEventListener('click', () => {
        const open = menu.hidden;
        menu.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? tr('menuClose') : tr('menuOpen'));
      });
      $$('a', menu).forEach(a => a.addEventListener('click', close));
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !menu.hidden) { close(); button.focus(); }
      });
    });
    $$('[data-dialog-open]', root).forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => document.getElementById(button.dataset.dialogOpen)?.showModal());
    });
    $$('dialog', root).forEach(dialog => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      $$('[data-dialog-close]', dialog).forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
    });
    $$('[data-project-filter]', root).forEach(section => {
      if (section.dataset.bound) return;
      section.dataset.bound = 'true';
      let expanded = section.hasAttribute('data-projects-expanded');
      let filter = 'all';
      const more = $('[data-projects-more]', section);
      const cards = $$('[data-project-category]', section);
      const updateProjects = () => {
        cards.forEach((card, index) => {
          const matches = filter === 'all' || card.dataset.projectCategory === filter;
          card.hidden = !matches || (filter === 'all' && !expanded && index >= 6);
        });
        if (more) {
          more.hidden = filter !== 'all' || cards.length <= 6;
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = tr(expanded ? 'showFewerProjects' : 'showAllProjects') + ' ↗';
        }
      };
      more?.addEventListener('click', () => { expanded = !expanded; updateProjects(); });
      $$('[data-filter]', section).forEach(button => button.addEventListener('click', () => {
        $$('[data-filter]', section).forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        filter = button.dataset.filter;
        updateProjects();
      }));
      updateProjects();
    });
    $$('[data-gallery]', root).forEach(dialog => {
      if (dialog.dataset.galleryBound) return;
      dialog.dataset.galleryBound = 'true';
      const thumbs = $$('[data-gallery-thumb]', dialog);
      const main = $('[data-gallery-main]', dialog);
      let selected = 0;
      const choose = index => {
        selected = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[selected];
        if (dialog.hasAttribute('data-roman-gallery')) dialog.toggleAttribute('data-small-detail', selected > 0);
        main.src = thumb.dataset.gallerySrc;
        main.alt = $('img', thumb).alt;
        $('[data-gallery-caption-text]', dialog).textContent = main.alt;
        $('[data-gallery-counter]', dialog).textContent = (selected + 1) + ' / ' + thumbs.length;
        thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
      };
      thumbs.forEach((button, index) => button.addEventListener('click', () => choose(index)));
      $$('[data-gallery-step]', dialog).forEach(button => button.addEventListener('click', () => choose(selected + Number(button.dataset.galleryStep))));
      dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); choose(selected + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); choose(selected - 1); }
      });
    });
    $$('[data-preview-language]', root).forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const url = new URL(select.selectedOptions[0].dataset.href, location.href);
        url.search = location.search;
        url.hash = location.hash;
        location.assign(url.href);
      });
    });
    $$('[data-language-select]', root).forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    $$('[data-product-section]', root).forEach(section => {
      const select = $('[data-variant-select]', section);
      if (!select || select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const d = option.dataset;
        const price = $('[data-product-price]', section);
        if (price) price.textContent = d.price;
        const compare = $('[data-product-compare-price]', section);
        if (compare) { compare.textContent = d.comparePrice || ''; compare.hidden = !d.comparePrice; }
        const button = $('[data-add-to-cart]', section);
        const available = d.available === 'true';
        if (button) {
          button.disabled = !available;
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
        }
        const stock = $('[data-stock-status]', section);
        if (stock) stock.textContent = available ? '' : (stock.dataset.soldOutMessage || tr('variantSoldOut'));
        const qty = $('[data-quantity]', section);
        if (qty) {
          qty.min = d.min || '1'; qty.step = d.increment || '1'; qty.value = qty.min;
          if (d.max) qty.max = d.max; else qty.removeAttribute('max');
        }
        const sku = $('[data-product-sku]', section);
        if (sku) { sku.hidden = !d.sku; $('[data-sku-value]', sku).textContent = d.sku || ''; }
        const url = new URL(location.href); url.searchParams.set('variant', option.value);
        history.replaceState(null, '', url);
      });
    });
    $$('[data-contact-product]', root).forEach(input => {
      if (!input.value && params.get('product')) input.value = productText(params.get('product'));
      if (!input.value && translations.projects[params.get('project')]) input.value = translations.projects[params.get('project')][language];
      if (!input.dataset.colorsPrefilled && requestedColors.length) {
        input.value = [input.value, ...requestedColors].filter(Boolean).join(tr('sampleSeparator'));
        input.dataset.colorsPrefilled = 'true';
      }
      if (!input.dataset.specialtyPrefilled && requestedSpecialty) {
        const entries = input.value.split(tr('sampleSeparator')).map(value => value.trim());
        if (!entries.includes(requestedSpecialty)) {
          input.value = [input.value, requestedSpecialty].filter(Boolean).join(tr('sampleSeparator'));
        }
        input.dataset.specialtyPrefilled = 'true';
      }
    });
    if (['quote', 'sample', 'trade', 'other'].includes(params.get('type'))) {
      const purpose = $('[data-contact-purpose]', root);
      if (purpose) purpose.value = params.get('type');
    }
  }
  bindUI();
  document.addEventListener('shopify:section:load', e => bindUI(e.target));
  // Native Shopify product, contact and cart submissions stay native.
  if (!preview) return;
  const allowedSamples = ['カーテン', 'ローマンシェード', 'ブラインド', '特殊シェード'];
  const storageKey = 'livearo-sample-consultation-v1';
  let samples = [];
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) samples = [...new Set(stored.filter(x => allowedSamples.includes(x)))];
  } catch (_) { /* The preview remains usable without browser storage. */ }
  function updateSamples() {
    try { localStorage.setItem(storageKey, JSON.stringify(samples)); } catch (_) {}
    $$('[data-sample-count]').forEach(el => { el.textContent = String(samples.length); el.hidden = !samples.length; });
    const list = $('[data-sample-list]');
    if (list) {
      list.replaceChildren();
      samples.forEach(name => {
        const li = document.createElement('li');
        const title = document.createElement('span'); title.textContent = productName(name);
        const remove = document.createElement('button'); remove.className = 'remove-sample';
        remove.textContent = tr('sampleRemove'); remove.setAttribute('aria-label', tr('sampleRemoveAria', { product: productName(name) }));
        remove.addEventListener('click', () => { samples = samples.filter(x => x !== name); updateSamples(); });
        li.append(title, remove); list.append(li);
      });
    }
    const empty = $('[data-sample-empty]'); if (empty) empty.hidden = samples.length > 0;
    const inquiry = $('[data-sample-inquiry]');
    if (inquiry) inquiry.href = 'contact.html?type=sample&product=' + encodeURIComponent(samples.join('、'));
    $$('[data-add-sample]').forEach(button => {
      const selected = samples.includes(button.dataset.addSample);
      button.textContent = tr(selected ? 'sampleAddedButton' : 'sampleAddButton');
      button.setAttribute('aria-pressed', String(selected));
    });
    document.dispatchEvent(new CustomEvent('livearo:generic-samples-updated', { detail: { count: samples.length } }));
  }
  $$('[data-add-sample]').forEach(button => button.addEventListener('click', () => {
    const name = button.dataset.addSample;
    if (!allowedSamples.includes(name)) return;
    if (!samples.includes(name)) { samples.push(name); showToast(tr('sampleAddedToast', { product: productName(name) })); }
    else showToast(tr('sampleAlreadyAddedToast'));
    updateSamples();
  }));
  $$('[data-open-samples]').forEach(button => button.addEventListener('click', () => $('#sample-drawer').showModal()));
  updateSamples();
  const type = $('#inquiry-type');
  if (type && ['quote', 'sample', 'trade', 'other'].includes(params.get('type'))) type.value = params.get('type');
  const form = $('[data-preview-form]');
  if (!form) return;
  form.addEventListener('submit', e => {
    e.preventDefault();
    if (!form.reportValidity()) return;
    const lines = [tr('savedFileHeading'), tr('savedFileNotice'), ''];
    for (const [key, raw] of new FormData(form).entries()) {
      const value = key === 'ご相談内容' ? $('#inquiry-type').selectedOptions[0].textContent : raw;
      if (value) lines.push((translations.formFields[key]?.[language] || key) + tr('fieldSeparator') + value);
    }
    const text = lines.join('\n');
    const url = URL.createObjectURL(new Blob(['\ufeff' + text], { type: 'text/plain;charset=utf-8' }));
    const a = document.createElement('a'); a.href = url; a.download = tr('savedFileName');
    document.body.append(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(url), 5000);
    const status = $('[data-form-status]');
    status.replaceChildren(document.createTextNode(tr('saveSuccess')));
    const mail = document.createElement('a'); mail.className = 'text-link';
    mail.textContent = tr('openEmailApp');
    mail.href = 'mailto:LIVEARO.JP@gmail.com?subject=' + encodeURIComponent(tr('emailSubject', { company: $('#company').value })) + '&body=' + encodeURIComponent(text);
    status.append(document.createElement('br'), mail); status.hidden = false;
  });
})();
